import * as React from 'react'
import { cn } from '@/shared/utils'

interface FormHeaderProps {
  eyebrow: string
  title: string
  description?: string
  className?: string
}

export function FormHeader({ eyebrow, title, description, className }: FormHeaderProps) {
  return (
    <div
      className={cn(
        'border-l-4 border-adventure-500 bg-adventure-50 px-4 py-3 rounded-r-md',
        className
      )}
    >
      <p className="text-xs font-semibold uppercase tracking-widest text-adventure-600 mb-0.5">
        {eyebrow}
      </p>
      <p className="text-base font-semibold text-foreground leading-snug">{title}</p>
      {description && (
        <p className="text-sm text-muted-foreground mt-1">{description}</p>
      )}
    </div>
  )
}
